/**
 * Knowledge Control admin access.
 *
 * Dedicated token (sessionStorage) remains for automation / operator paste.
 * HMVMAuth owner JWT opens the same UI via cookie — never bake the env token
 * into VITE_*.
 */

export const KNOWLEDGE_ADMIN_TOKEN_KEY = 'hmvm:reviewer:knowledge-control:admin-token'

export class KnowledgeControlAuthError extends Error {
  status: number

  constructor(message: string, status = 401) {
    super(message)
    this.name = 'KnowledgeControlAuthError'
    this.status = status
  }
}

export function loadKnowledgeAdminToken(): string | null {
  try {
    const value = sessionStorage.getItem(KNOWLEDGE_ADMIN_TOKEN_KEY)
    return value && value.trim() ? value.trim() : null
  } catch {
    return null
  }
}

export function saveKnowledgeAdminToken(token: string): void {
  sessionStorage.setItem(KNOWLEDGE_ADMIN_TOKEN_KEY, token.trim())
}

export function clearKnowledgeAdminToken(): void {
  try {
    sessionStorage.removeItem(KNOWLEDGE_ADMIN_TOKEN_KEY)
  } catch {
    // ignore storage failures
  }
}

export function ssoCanManageKnowledge(role: string | null | undefined): boolean {
  const normalized = (role || '').trim().toLowerCase()
  return normalized === 'owner' || normalized === 'admin'
}

export async function resolveKnowledgeAdminAccess(
  me: () => Promise<{ role?: string }>,
): Promise<boolean> {
  if (loadKnowledgeAdminToken()) return true
  try {
    const session = await me()
    return ssoCanManageKnowledge(session.role)
  } catch {
    return false
  }
}
